export default "__VITE_ASSET__C5j9iZ_Z__"